/*
 * @Descripttion: 公告详情页
 * @Author: 曹博
 * @Date: 2023-08-28 17:38:13
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-16 15:02:10
 */
import styles from './styles.module.scss'
import UseXhNoticeDetailHook from './hooks'
import { Divider } from 'antd'
import moment from 'moment'
import PreviewModal from '../../components/previewModal'
import DownloadIcon from '../../assets/img/download.png'
import Mp4 from '../../assets/img/MP4.png'
import Excel from '../../assets/img/EXCEL.png'
import Img from '../../assets/img/IMG.png'
import Pdf from '../../assets/img/PDF.png'
import Ppt from '../../assets/img/PPT.png'
import Rar from '../../assets/img/RAR.png'
import Word from '../../assets/img/WORD.png'

const style = {
  width: '15px',
  height: '15px',
}

export const fileTypeIcon = (type: string) => {
  if (['GIF', 'PNG', 'JPG', 'JPEG'].includes(type)) {
    return <img src={Img} style={style}></img>
  } else if (['ZIP', 'RAR', '7Z', 'TAR'].includes(type)) {
    return <img src={Rar} style={style}></img>
  } else if (['DOC', 'DOCX'].includes(type)) {
    return <img src={Word} style={style}></img>
  } else if (['XLS', 'XLSX', 'XLSM'].includes(type)) {
    return <img src={Excel} style={style}></img>
  } else if (type === 'PDF') {
    return <img src={Pdf} style={style}></img>
  } else if (['PPT', 'PPTX'].includes(type)) {
    return <img src={Ppt} style={style}></img>
  } else if (['AVI', 'MP4', 'FLV'].includes(type)) {
    return <img src={Mp4} style={style}></img>
  } else {
    return ''
  }
}

const XhAnnouncement = () => {
  const { hookstate, showPreviewModal, cancelPreviewModal, onDownloadFile } =
    UseXhNoticeDetailHook()
  const { dataSource, attachmentList, previewFileUrl, isPreviewModalVisible } =
    hookstate

  return (
    <div className={styles.container}>
      <p className={styles.title}>{dataSource.title}</p>
      <div className={styles.other}>
        <span>发布时间：</span>
        <span>
          {dataSource.createTime
            ? moment(new Date(dataSource.createTime)).format(
                'YYYY-MM-DD HH:mm:ss',
              )
            : ''}
        </span>
        <span style={{ display: 'inline-block', marginLeft: '20px' }}>
          发布人：
        </span>
        <span className={styles['info-font']}>
          {dataSource.createMan || '-'}
        </span>
      </div>
      <Divider style={{ margin: '20px 0' }} />
      <div
        dangerouslySetInnerHTML={{ __html: dataSource.content }}
        className={styles.content}
      ></div>
      <Divider style={{ margin: '20px 0' }} />
      {attachmentList.length ? (
        <ul style={{ listStyleType: 'none' }}>
          {attachmentList.map((item: any) => {
            return (
              <li key={item.filename}>
                {fileTypeIcon(item.type)}
                <span
                  className={styles['attachmentList-name']}
                  onClick={() => showPreviewModal(item)}
                >
                  {item.filename}
                </span>
                <img
                  src={DownloadIcon}
                  className={styles['download-icon']}
                  onClick={() => onDownloadFile(item)}
                />
              </li>
            )
          })}
        </ul>
      ) : (
        ''
      )}
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
      />
    </div>
  )
}

export default XhAnnouncement
/*
 * @Descripttion: 公告详情页
 * @Author: 曹博
 * @Date: 2023-08-28 17:38:13
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-16 15:02:10
 */
import styles from './styles.module.scss'
import UseXhNoticeDetailHook from './hooks'
import { Divider } from 'antd'
import moment from 'moment'
import PreviewModal from '../../components/previewModal'
import DownloadIcon from '../../assets/img/download.png'
import Mp4 from '../../assets/img/MP4.png'
import Excel from '../../assets/img/EXCEL.png'
import Img from '../../assets/img/IMG.png'
import Pdf from '../../assets/img/PDF.png'
import Ppt from '../../assets/img/PPT.png'
import Rar from '../../assets/img/RAR.png'
import Word from '../../assets/img/WORD.png'

const style = {
  width: '15px',
  height: '15px',
}

export const fileTypeIcon = (type: string) => {
  if (['GIF', 'PNG', 'JPG', 'JPEG'].includes(type)) {
    return <img src={Img} style={style}></img>
  } else if (['ZIP', 'RAR', '7Z', 'TAR'].includes(type)) {
    return <img src={Rar} style={style}></img>
  } else if (['DOC', 'DOCX'].includes(type)) {
    return <img src={Word} style={style}></img>
  } else if (['XLS', 'XLSX', 'XLSM'].includes(type)) {
    return <img src={Excel} style={style}></img>
  } else if (type === 'PDF') {
    return <img src={Pdf} style={style}></img>
  } else if (['PPT', 'PPTX'].includes(type)) {
    return <img src={Ppt} style={style}></img>
  } else if (['AVI', 'MP4', 'FLV'].includes(type)) {
    return <img src={Mp4} style={style}></img>
  } else {
    return ''
  }
}

const XhAnnouncement = () => {
  const { hookstate, showPreviewModal, cancelPreviewModal, onDownloadFile } =
    UseXhNoticeDetailHook()
  const { dataSource, attachmentList, previewFileUrl, isPreviewModalVisible } =
    hookstate

  return (
    <div className={styles.container}>
      <p className={styles.title}>{dataSource.title}</p>
      <div className={styles.other}>
        <span>发布时间：</span>
        <span>
          {dataSource.createTime
            ? moment(new Date(dataSource.createTime)).format(
                'YYYY-MM-DD HH:mm:ss',
              )
            : ''}
        </span>
        <span style={{ display: 'inline-block', marginLeft: '20px' }}>
          发布人：
        </span>
        <span className={styles['info-font']}>
          {dataSource.createMan || '-'}
        </span>
      </div>
      <Divider style={{ margin: '20px 0' }} />
      <div
        dangerouslySetInnerHTML={{ __html: dataSource.content }}
        className={styles.content}
      ></div>
      <Divider style={{ margin: '20px 0' }} />
      {attachmentList.length ? (
        <ul style={{ listStyleType: 'none' }}>
          {attachmentList.map((item: any) => {
            return (
              <li key={item.filename}>
                {fileTypeIcon(item.type)}
                <span
                  className={styles['attachmentList-name']}
                  onClick={() => showPreviewModal(item)}
                >
                  {item.filename}
                </span>
                <img
                  src={DownloadIcon}
                  className={styles['download-icon']}
                  onClick={() => onDownloadFile(item)}
                />
              </li>
            )
          })}
        </ul>
      ) : (
        ''
      )}
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
      />
    </div>
  )
}

export default XhAnnouncement
